// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"91fbe4797c08097b4dfc","240":"ab16b7cb115fe9717ecf"}[chunkId] + ".js";
};